import { Directive, ElementRef, OnInit, Renderer2 } from '@angular/core';

@Directive({ selector: '[appExternalLink]' })
export class ExternalLinkDirective implements OnInit {
	constructor(
		private el: ElementRef,
		private renderer: Renderer2
	) {}

	ngOnInit(): void {
		this.renderer.setAttribute(
			this.el.nativeElement,
			'rel',
			'noopener noreferrer'
		);
		if (!this.el.nativeElement.hasAttribute('target')) {
			this.renderer.setAttribute(this.el.nativeElement, 'target', '_blank');
		}
	}
}
